import React from 'react';
import Wishlist from '../../components/home/wishlistComponent/Wishlist';

export default function WishlistPage() {
  return (
    <div className="w-full">
      <Wishlist />
    </div>
  );
}
